<h2 mat-dialog-title>
  Draft Section
  <button
    mat-icon-button
    style="margin-left: auto; position: absolute; top: 0; right: 0"
    class="close-button"
    (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <mat-form-field class="full-width" color="accent">
    <textarea matInput [(ngModel)]="prompt" rows="4" placeholder="{{ placeholder }}"></textarea>
  </mat-form-field>
  <mat-dialog-actions>
    <button mat-raised-button [disabled]="inProgress" (click)="onSubmit()">Submit</button>
  </mat-dialog-actions>
  <mat-card class="response-card" *ngIf="inProgress || fullResponse">
    <mat-card-content class="preview-content">
      <pre class="response-text">{{ response }}</pre>
    </mat-card-content>
    <mat-spinner *ngIf="inProgress" class="bottom-right-spinner" [diameter]="40"></mat-spinner>
    <button
      mat-icon-button
      *ngIf="response"
      class="bottom-right-spinner"
      color="accent"
      matTooltip="Copy to clipboard"
      (click)="copyToClipboard()">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-card>
</mat-dialog-content>
